var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"py-2"},[_c('FlyoutMenuHead',{attrs:{"selectedItem":_vm.getSelectedDevice,"type":"edit","route":"devices"}}),_c('v-divider'),_c('CustomForm',{attrs:{"formData":_vm.formData,"type":"edit","currentData":_vm.getSelectedDevice,"loading":_vm.loader},on:{"onAddTag":_vm.addNewTag,"onSubmit":_vm.editDevice,"onClose":() => {
            this.$router.go(-1);
          }}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }